import { useLayoutEffect } from "react";
import type { Settings } from "@/domain/settings/model/settings";
import { createSettingsRepository } from "@/infrastructure/persistence/settings-repository-factory";
import { type UiStore, useUiStore } from "../stores/uiStore";

function extractSettings(state: UiStore): Settings {
  return {
    volume: state.volume,
    muted: state.muted,
    mobileGuideAcknowledged: state.mobileGuideAcknowledged,
    narrationSpeedMultiplier: state.narrationSpeedMultiplier,
    reduceMotionOverride: state.reduceMotionOverride,
  };
}

/**
 * 起動時に一度`Settings`をリポジトリから読み込み`uiStore`へ反映し、以後の変更を
 * 都度リポジトリへ保存する（`vimquest.settings.v1`。計画8実施メモにより計画13の担当）。
 * `useProgressBootstrap`と同じく、初期状態のちらつきを避けるため`useLayoutEffect`で行う。
 */
export function useSettingsSync(): void {
  useLayoutEffect(() => {
    const repository = createSettingsRepository();
    useUiStore.setState(repository.load());
    return useUiStore.subscribe((state) => {
      repository.save(extractSettings(state));
    });
  }, []);
}
